import { useState, useMemo } from 'react'
import { Input } from '@pancakeswap/uikit'
import styled from 'styled-components'
import debounce from 'lodash/debounce'

const StyledInput = styled(Input)`
  border-radius: 16px;
  background-color : #1A3342;
  border : none !important;
  box-shadow: 0px 0px 0px 1px #00FED9 ;
  margin-left: auto;
  font-weight: 400;
  /* width: 150px; */
  color : #ffffff;
  &:focus {
    box-shadow: 0px 0px 0px 1px #00FED9 !important ;
  }
  ::placeholder {
  color: white;
}
/* ${({ theme }) => theme.mediaQueries.lg} {
    width: 120px;
  } */
`

const InputWrapper = styled.div`
  position: relative;
  ${({ theme }) => theme.mediaQueries.sm} {
    display: block;
    width:'50px';
  }
`
interface SearchData {
  setSearchValue?: any;
}
const SearchInput: React.FC<SearchData> = ({ setSearchValue }) => {

  return (
    <InputWrapper>
      <StyledInput placeholder='Search' onChange={(e) => setSearchValue(e.target.value)} />
    </InputWrapper>
  )
}

export default SearchInput
